export const COVER_IMAGE =
  "https://www.modusprofumerie.it/images/cover/modus_cover.png"
